import type { ApplicationModuleConfig } from './environment.model';

export const applicationModules = {
  ISR: {
    routePrefix: '/issuer',
    defaultRoute: '/issuer/analitica',
    label: 'Portal Estipulante/Representante',
  },
  EQA: {
    routePrefix: '/eqauth',
    defaultRoute: '/eqauth/users',
    label: 'Administração Auth',
  },
  PAY: {
    routePrefix: '/pagamentos',
    defaultRoute: '/pagamentos/pagamentos',
    label: 'Pagamentos',
  },
  POG: {
    routePrefix: '/portal-gestao',
    defaultRoute: '/portal-gestao',
    label: 'Portal Gestão',
    externalUrl: 'https://tech.infiniteflow.com.br/webhook/portal-gestao',
  },
} as const satisfies Record<string, ApplicationModuleConfig>;
